import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import PhoneLink from 'components/common/PhoneLink'
import PrintButton from 'components/common/PrintButton/PrintButton'

const AppointmentDetails = ({
  address: {
    address1,
    city,
    state,
    zipcode
  },
  phone,
  googleMapsDirections,
  showUpdateCancelInstructionsModalHandler,
  isUpcomingAppointment,
  printHandler,
  emailModalProps
}) =>
  <Fragment>
    <AddressBlock>
      <VehicleText data-at-appointment-vehicletext>Bring your vehicle to</VehicleText>
      <div data-at-appointment-address>
        <Media.Desktop>
          <div>
            { address1 }<br />
            { city }, { state } { zipcode }<br />
            { phone }
          </div>
        </Media.Desktop>
        <Media.Mobile>
          <A bolder href={ googleMapsDirections }>
            { address1 }<br />
            { city }, { state } { zipcode }
          </A>
          <div>
            <PhoneLink bolder number={ phone } />
          </div>
        </Media.Mobile>
      </div>
    </AddressBlock>

    <LinksBlock>
      <LineLink
        data-at-appointment-viewstoredirections
        bolder
        href={ googleMapsDirections }>Get Directions</LineLink>
      {
        isUpcomingAppointment &&
          <LineLink
            data-at-appointment-editappointment
            prevent
            bolder
            handler={ showUpdateCancelInstructionsModalHandler }>
            Update/Cancel Appointment
          </LineLink>
      }
      <UtilityLinks>
        <PrintButton data-at-appointment-print title="Print" handler={ printHandler } />
        {/* <Separator />
        <SharePageViaEmail title="Email" modalProps={ emailModalProps } /> */}
      </UtilityLinks>
    </LinksBlock>
  </Fragment>

AppointmentDetails.propTypes = {
  address: PropTypes.shape({
    address1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipcode: PropTypes.string
  }),
  emailModalProps: PropTypes.shape(),
  googleMapsDirections: PropTypes.string,
  isUpcomingAppointment: PropTypes.bool,
  phone: PropTypes.string,
  printHandler: PropTypes.func,
  showUpdateCancelInstructionsModalHandler: PropTypes.func
}

export default AppointmentDetails

const AddressBlock = styled.div`
  line-height: 22px;
  ${Media.desktop`
    float: left;
    width: 300px;
  `}
  ${Media.mobile`
    max-width: 250px;
    margin-bottom: 24px;
  `}
`

const VehicleText = styled.div`
  margin-bottom: 8px;
  font-style: italic;
  color: ${Theme.colors.sub_grey};
  ${Mixin.font.GothamBold(14, 600, 22)}
`

const LineLink = styled(A)`
  display: inline-block;
  line-height: 30px;
`

// const Separator = styled.span`
//   display: inline-block;
//   height: 16px;
//   margin: 0 12px;
//   vertical-align: middle;
//   border-right: 1px solid ${Theme.colors.light_grey};
// `

const LinksBlock = styled.div`
  width: 200px;
  ${Media.desktop`
    float: right;
  `}
  ${Mixin.responsive('margin-right', '95px', '0')}
`

const UtilityLinks = styled.div`
  display: inline-block;
  margin-top: 8px;
`
